import React from 'react';
import OverViewPage from './pages/OverViewPage';
const Home = () => (<OverViewPage />);
export default Home;